import AnyAction from 'store/anyActions';

import UserTypes from '../user/user.types';
import MetricsState from './metrics.state';
import MetricTypes from './metrics.types';

const defaultState: MetricsState = {
    filters: {
        timeRange: 'midnight',
    },
    agentUpdates: [],
};

export default function (state: MetricsState = defaultState, action: AnyAction): MetricsState {
    switch (action.type) {
        //This can be removed once old time ranges are flushed out from localstorage
        case UserTypes.LOGIN:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    timeRange: typeof state.filters.timeRange === 'string' ? 'midnight' : state.filters.timeRange,
                },
            };
        case MetricTypes.GET_AGENT_METRICS:
            return {
                ...state,
                agentMetrics: action.payload,
                agentUpdates: [],
                agentsLoading: false,
            };
        case MetricTypes.GET_AGENT_STATUSES:
            return {
                ...state,
                agentsLoading: false,
                agentStatuses: action.payload,
            };
        case MetricTypes.SET_STATS_QUEUE_METRICS:
            return { ...state, statsQueueMetrics: action.payload, queuesLoading: false };
        case MetricTypes.SET_REALTIME_QUEUE_METRICS:
            return { ...state, realtimeQueueMetrics: action.payload, queuesLoading: false };
        case MetricTypes.SET_WEBSOCKET_QUEUE_METRICS:
            return { ...state, websocketQueueMetrics: action.payload, queuesLoading: false };
        case MetricTypes.SET_METRICS_CONFIG:
            return { ...state, metricsGroups: action.payload };
        case MetricTypes.SET_METRICS_CONFIG_V2:
            return { ...state, config: action.payload };
        case MetricTypes.LOADING_AGENT_METRICS:
            return { ...state, agentsLoading: true };
        case MetricTypes.LOADING_QUEUE_METRICS:
            return { ...state, queuesLoading: true };
        case MetricTypes.SET_METRIC_FILTERS:
            return { ...state, filters: { ...state.filters, ...action.payload } };
        case MetricTypes.ADD_AGENT_UPDATE:
            return {
                ...state,
                agentUpdates: [...state.agentUpdates, action.payload],
            };
        case MetricTypes.MONITOR_AGENT:
            if (!state) return state;
            return { ...state, monitoringAgent: action.payload };
        case MetricTypes.STOP_MONITOR_AGENT:
            delete state.monitoringAgent;
            return { ...state };
        default:
            return state;
    }
}
